import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ConfirmationComponent } from '../pages/shared/confirmation/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

export interface ConfirmationOptions {
  message: string;
  hideClose?: boolean; // true = hide close icon
  title?: string;          // title for the dialog
  heading?: boolean;        // true = show custom heading
  heading_text?: string;    // custom heading text
  button?: boolean;         // true = only Ok, false = Yes/No
  width?: string;
  height?: string;
  autoClose?: boolean;  // true = auto close on action, false = manual close
}

export interface Client {
  id: number | 'all';
  client_name: string;
  address: any;
  state: any;
  country: any;
  value: number;
  viewValue: string;
}
export interface GlobalFilter {
  isShow: boolean;
}

export interface Warehouse {
  id: number;
  name: string;
  value: number;
  viewValue: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zip_code: string;
  region: any;
  phone: string;
}
export interface Guide {
 step:number
}

@Injectable({ providedIn: 'root' })
export class CommonService {
  private subjectName = new Subject<any>();
  private clients$ = new BehaviorSubject<Client[] | null>(null);
  private warehouses$ = new BehaviorSubject<any[] | null>(null);
   private filterWarehouses$ = new BehaviorSubject<any[] | null>(null);
  private selectedClient$ = new Subject<Client | null>();
  private selectedWarehouse$ = new Subject<Warehouse | null>();
  private startQuide$ = new Subject<Guide | null>();
  private GlobalFilter$ = new Subject<GlobalFilter | null>();


  constructor(public dialog: MatDialog,
    private location: Location,
    private router: Router,
  ) { }




  sendUpdate(message: string) {
    this.subjectName.next({ text: message });
    console.log('c', message);
  }

  getUpdate(): Observable<any> {
    return this.subjectName.asObservable();
  }

  setClients(clients: Client[]) {
    this.clients$.next(clients);
  }
  setGlobalFilters(isShow: GlobalFilter) {
    this.GlobalFilter$.next(isShow);
  }
  getGlobalFilters() {
    return this.GlobalFilter$.asObservable();
  }


  getClients() {
    return this.clients$;
  }

 
  setFilterWarehouses(warehouses: any[]) {
    this.filterWarehouses$.next(warehouses);
  }

  getFilterWarehouses() {
    return this.filterWarehouses$.asObservable();
  }

  setWarehouses(warehouses: Warehouse[]) {
    this.warehouses$.next(warehouses);
  }

  getWarehouses() {
    return this.warehouses$;
  }

  setSelectedClient(client: Client) {
    this.selectedClient$.next(client);
  }

  getSelectedClient() {
    return this.selectedClient$.asObservable();
  }

  setSelectedWarehouse(warehouse: Warehouse | null) {
    this.selectedWarehouse$.next(warehouse);
  }

  getSelectedWarehouse() {
    return this.selectedWarehouse$.asObservable();
  }

  private selectedWarehouses$ = new BehaviorSubject<any[]>([]);

  setSelectedWarehouses(warehouses: any[]) {
    this.selectedWarehouses$.next(warehouses);
  }

  getSelectedWarehouses(): Observable<any[]> {
    return this.selectedWarehouses$.asObservable();
  }
  setStartQuide(guide: Guide) {
    this.startQuide$.next(guide);
  }

  getStartGuide() {
    return this.startQuide$.asObservable();
  }
  downloadCSVFile(data: string, fileName: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    const link = document.createElement('a');
    const date = new Date();
    link.download = `${fileName}_${date.toLocaleDateString()}.csv`;
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcelFile(blob: Blob, fileName: string) {
    const link = document.createElement('a');
    link.download = `${fileName}.xlsx`;
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  downloadJSONtoCSVFile(jsonData: any[], fileName: string) {
    if (!jsonData || !jsonData.length) {
      console.error('No data available to download.');
      return;
    }

    const csvRows = [];

    const headers = Object.keys(jsonData[0]);
    csvRows.push(headers.join(',')); // Join the keys with a comma

    for (const row of jsonData) {
      const values = headers.map(header => {
        const escapedValue = (row[header] !== null && row[header] !== undefined)
          ? ('' + row[header]).replace(/"/g, '""')
          : '';
        return `"${escapedValue}"`;
      });
      csvRows.push(values.join(','));
    }

    const csvString = csvRows.join('\n');

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    const date = new Date();
    const fileTitle = `${fileName}_${date.toLocaleDateString().replace(/\//g, '-')}.csv`;

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileTitle);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadCSVFromObjectArray(data: { [key: string]: any }[], fileName: string): void {
    if (!data || !data.length) {
      console.error('No data available to download.');
      return;
    }

    const csvRows: string[] = [];

    // Extract headers from keys of the first object
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(',')); // e.g. "row,error"

    // Map each object to a CSV row
    for (const row of data) {
      const values = headers.map(header => {
        const value = row[header];
        const escaped = value !== null && value !== undefined
          ? String(value).replace(/"/g, '""') // Escape double quotes
          : '';
        return `"${escaped}"`; // Enclose in quotes
      });
      csvRows.push(values.join(','));
    }

    // Join all rows with newline
    const csvContent = csvRows.join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const date = new Date();
    const fileTitle = `${fileName}_${date.toISOString().split('T')[0]}.csv`; // yyyy-mm-dd

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileTitle);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  setItemToLocalStorage(key:any, data:any, updateKeys:any) {
  try {
    // Retrieve existing data from localStorage
    const existingData = localStorage.getItem(key);

    // Parse existing data if available, otherwise initialize as empty object
    let parsedData = existingData ? JSON.parse(existingData) : {};

    // Ensure updateKeys is treated as an array (convert if it's a string)
    if (typeof updateKeys === "string") {
      updateKeys = [updateKeys];
    }

    if (Array.isArray(updateKeys) && updateKeys.length > 0) {
      // Update only specified keys
      updateKeys.forEach((updateKey) => {
        if (data.hasOwnProperty(updateKey)) {
          parsedData[updateKey] = data[updateKey]; // Update specific property
        }
      });
    } else {
      // If no updateKeys are provided, merge the entire data object
      Object.assign(parsedData, data);
    }

    // Store updated data in localStorage
    localStorage.setItem(key, JSON.stringify(parsedData));
  } catch (error) {
    console.error("Error storing/updating data in localStorage", error);
  }
}



removeItemsFromLocalStorage(key:any, objKeys:any) {
  try {
    // Retrieve existing data from localStorage
    const existingData = localStorage.getItem(key);

    if (existingData) {
      let parsedData = JSON.parse(existingData);

      // Set specified keys to an empty object
      objKeys.forEach((objKey:any) => {
        if (parsedData.hasOwnProperty(objKey)) {
          parsedData[objKey] = null;
        }
      });

      // Update localStorage with modified data
      localStorage.setItem(key, JSON.stringify(parsedData));
    }
  } catch (error) {
    console.error('Error removing items from localStorage', error);
  }
}


  getLocalStorageData(key:any) {
    try {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        return JSON.parse(storedValue);
      }
      return null;
    } catch (error) {
      console.error('Error reading data from localStorage', error);
      return null;
    }
  }

  analyzeDateRange(startDate: Date, endDate: Date): {
      days: number;
      weeks: number;
      months: number;
      years: number;
      label: 'invalid' | 'weekly' | 'monthly' | 'yearly';
    } {
  
      if (!startDate || !endDate) {
        return {
          days: 0,
          weeks: 0,
          months: 0,
          years: 0,
          label: 'invalid',
        };
      }
      
  
      const start = new Date(startDate);
      const end = new Date(endDate);
  
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
  
      const msInDay = 1000 * 60 * 60 * 24;
      const dayDiff = Math.floor((end.getTime() - start.getTime()) / msInDay);
  
      const weekDiff = dayDiff / 7;
  
      const years =
        end.getFullYear() - start.getFullYear() -
        (end.getMonth() < start.getMonth() ||
          (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())
          ? 1
          : 0);
  
      const months =
        (end.getFullYear() - start.getFullYear()) * 12 +
        end.getMonth() -
        start.getMonth() -
        (end.getDate() < start.getDate() ? 1 : 0);
  
      const isFullCalendarMonth =
        start.getDate() === 1 &&
        end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();
  
      // Final label decision
      let label: 'invalid' | 'weekly' | 'monthly' | 'yearly';
  
      if (years >= 1) {
        label = 'yearly';
      } else if (months >= 1 || isFullCalendarMonth) {
        label = 'monthly';
      } else if (dayDiff >= 6) {
        label = 'weekly';
      } else {
        label = 'invalid';
      }
  
      return {
        days: dayDiff,
        weeks: +weekDiff.toFixed(2),
        months,
        years,
        label
      };
    }

  openConfirmationDialog(options: ConfirmationOptions): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      panelClass: 'confirmation-popup-container',
      data: {
        width: options.width ?? '320px',
        height: options.height ?? '200px',
        heading: options.heading ?? false,
        heading_text: options.heading_text ?? '',
        button: options.button ?? false,
        message: options.message,
        title: options.title,
        hideClose: options.hideClose,
        autoClose: options.autoClose,
      },
    });

    return dialogRef.beforeClosed(); // returns "0" or "1" (from your closeDialog)
  }

  formatFieldName(field: string = ''): string {
    return field
      .split('_')                   // split by underscore
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )                             // capitalize each word
      .join(' ');                   // join back with space
  }

}
